import type { VpIconProps } from '@vtmn-play/react/headless';
import type { MessageKeys } from 'next-intl';
import type { Messages } from '@/global';

export const buttonValidation = (
  lastInformation: boolean,
): {
  icon: VpIconProps['name'];
  title: MessageKeys<
    Messages,
    'PROFILE.COMPLETION.COMMON.NEXT_BUTTON' | 'PROFILE.GLOBAL.VALIDATE'
  >;
} => {
  if (!lastInformation) {
    return {
      icon: 'arrow-right',
      title: 'PROFILE.COMPLETION.COMMON.NEXT_BUTTON',
    };
  } else {
    return { icon: null, title: 'PROFILE.GLOBAL.VALIDATE' };
  }
};
